import { render } from "./StoragesAdmin.vue?vue&type=template&id=30b9b1b8"
import script from "./StoragesAdmin.vue?vue&type=script&lang=js"
export * from "./StoragesAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__